
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configure/[handle]",
      function () {
        return require("private-next-pages/configure/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/configure/[handle]"])
      });
    }
  